












































































































































































import { computed, ComputedRef, defineComponent, ref, watch } from '@vue/composition-api';
import {
  LoadingIcon,
  SearchIcon,
  CheckIcon,
  CloseIcon,
  ChevronRightIcon,
  FolderAddIcon,
  StarIcon,
  ForkIcon,
  UsergroupIcon,
  UserIcon,
  ArrowLeftIcon,
} from 'tdesign-icons-vue';
import _ from 'lodash';

import TeamTree from '@/renderer/components/TeamTree/index.vue';
import Breadcrumb from '@/renderer/components/SpacePage/components/Breadcrumb.vue';

import dirListHandler from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/compositions/dirListHandler';
import newFolderHandler from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/compositions/newFolderHandler';
import searchHandler from '@/renderer/components/dialog/SelectAnySpaceTargetFolder/compositions/searchHandler';
import { renderFileNameEle } from '@/renderer/scripts/composition/renderFileEle';
import { SMH } from '@/renderer/scripts/smh';
import i18n, { i18n_t } from '@/locales/i18n';
import spaceATM from '@/renderer/scripts/utils/AccessTokenManager/space';

export default defineComponent({
  name: 'SelectSpacePath',
  components: {
    LoadingIcon,
    SearchIcon,
    CheckIcon,
    CloseIcon,
    ChevronRightIcon,
    FolderAddIcon,
    TeamTree,
    Breadcrumb,
    StarIcon,
    ForkIcon,
    UsergroupIcon,
    UserIcon,
    ArrowLeftIcon,
  },
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    // title--表示弹窗标题
    title: {
      required: false,
      type: String,
      default: i18n_t('选择文件夹'),
    },
    // isSteps--腾讯文档导出有步骤
    isSteps: {
      required: false,
      type: Boolean,
      default: false,
    },
    // 是否显示复选框
    showCheckbox: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const store = context.root.$store;

    const innerShow = computed({
      get: () => props.show,
      set: val => {
        context.emit('update:show', val);
      },
    });

    // 默认初始化菜单栏打开企业空间
    const menuValue = ref('enterprise');
    const defaultExpanded = ref(['enterprise']);

    const steps = [i18n_t('选择导出文档'), i18n_t('选择导入腾讯文档位置')];
    const current = ref(1); // 代表步骤，导出腾讯文档需要

    const spaceName = ref('');
    const currentTeamNodeId = ref('');
    const currentGroupSpaceId = ref('');
    const personSpaceId = ref('');
    const spaceId = computed(() => {
      if (menuValue.value === 'personal') {
        return personSpaceId.value;
      }
      if (defaultExpanded.value[0] === 'enterprise') {
        return currentTeamNodeId.value;
      }
      if (defaultExpanded.value[0] === 'group') {
        return currentGroupSpaceId.value;
      }
      return '';
    });
    const spaceOrgId = ref(store.getters.orgId);
    const isSearchDirTruly = ref(true);
    const {
      currentSubDirList,
      currentGroupList,
      isLoading: isDirLoading,
      isGroupLoading,
      isDirMoreLoading,
      dirCrumbs,
      dirPath,
      dirPathString,
      dirHasMore,
      methods: listMethods,
    } = dirListHandler(spaceId, spaceOrgId);

    const { newFolderName, isShowNewFolder, handeleCreateNewFolder, isShowNewFolderErrorTips, newFolderErrorTips } =
      newFolderHandler(spaceId);

    const {
      searchKey,
      isSearching,
      isSearchLoading,
      isLoadMoreLoading: isSearchMoreLoading,
      searchResponse,
      methods: searchMethods,
    } = searchHandler(spaceId, isSearchDirTruly);

    const searchPath = computed(() => {
      if (dirPathString.value) {
        return dirPath.value.slice(-1)[0];
      }
      return spaceName.value;
    });

    // 加载更多：文件搜索时返回搜索list 否则正常文件拉取list
    const list = computed(() => {
      if (isSearching.value) return searchResponse.contents;
      return currentSubDirList.value;
    });

    // 加载loading：文件列表加载loading ｜ 文件搜索loading
    const loading = computed(() => isDirLoading.value || isSearchLoading.value);

    // 加载更多：dirHasMore | 文件搜索时content.hasmore
    const hasMore = computed(
      () => (!isSearching.value && dirHasMore.value) || (isSearching.value && searchResponse.hasMore),
    );

    // 正在加载更多
    const isLoadingMore = computed(() => isDirMoreLoading.value || isSearchMoreLoading.value);

    // 面包屑
    const rootCrumbsDefault: ComputedRef<string | string[]> = computed(() => {
      let crumbsRoot = '';
      if (isSearching.value) {
        crumbsRoot = i18n_t('搜索结果');
      } else {
        crumbsRoot = spaceName.value;
      }
      return crumbsRoot;
    });
    const crumbsList = computed(() => {
      const rootCrumbs = Array.isArray(rootCrumbsDefault.value) ? rootCrumbsDefault.value : [rootCrumbsDefault.value];
      const crumbsWithFirst = rootCrumbs.map(item => ({
        name: item,
        path: '',
      }));
      const crumbsWithDir = dirCrumbs.value.slice(1).map(item => ({
        ...item,
        name: item.name,
        path: item.path?.join('/') || '',
      }));
      let crumbs: {
        name: string;
        path?: string;
      }[] = [...crumbsWithFirst, ...crumbsWithDir];
      // 处理面包屑省略
      if (crumbs.length > 3) {
        crumbs = [crumbs[0], ...[{ name: '...' }], crumbs[crumbs.length - 1]];
      }
      return crumbs.map(item => ({
        ...item,
        content: item.name,
        type: 'dir',
        path: item.path,
      }));
    });

    const methods = {
      onExpandedMenu(expandedVal: string[]) {
        defaultExpanded.value = expandedVal;
        if (expandedVal[0] === 'group') {
          menuValue.value = String(currentGroupList.value[0].id);
          currentGroupSpaceId.value = currentGroupList.value[0].spaceId;
          spaceOrgId.value = currentGroupList.value[0].orgId;
          spaceName.value = currentGroupList.value[0].name;
        } else {
          menuValue.value = 'enterprise';
        }
      },
      onChangeMenu(menuVal: string) {
        if (menuVal === 'personal') {
          defaultExpanded.value = [];
          spaceName.value = i18n_t('个人空间');
        }
      },
      onChangeTeam(node: { data: SMH.TeamTreeNode; init: boolean }) {
        if (!node) return;
        if (node.init) return;
        const selectedTeam = node.data;
        spaceName.value = selectedTeam.name;
        currentTeamNodeId.value = selectedTeam.spaceId;
      },
      onChangeGroup(item: SMH.ColleborationSpaceInfoData) {
        currentGroupSpaceId.value = item.spaceId;
        spaceOrgId.value = item.orgId;
        spaceName.value = item.name;
      },
      // 进入下一级文件目录
      onClickItem(item: SMH.SpaceFileItemData) {
        if (item.type === 'file') return;
        if (isSearching.value) {
          searchMethods.onCancel();
        }
        methods.onChangeCrumbs(item, 'add');
      },
      onChangeCrumbs(item: SMH.SpaceFileItemData, action?: 'add' | 'replace' | 'remove', index?: number) {
        if (item.name === '...') {
          dirCrumbs.pop();
        } else {
          if (action === 'add') {
            dirCrumbs.push(item);
          } else if (action === 'remove') {
            dirCrumbs.value.splice((index as number) + 1);
          }
        }
      },
      // 清除搜索
      handleClearInput() {
        searchKey.value = '';
        searchMethods.onSearch();
      },
      // 加载更多
      loadMore() {
        // 搜索时的加载更多
        if (searchResponse.hasMore) {
          searchMethods.onLoadMore();
        } else if (dirHasMore.value) {
          // 查询文件时加载更多
          listMethods.onLoadMore();
        }
      },
      async initData() {
        personSpaceId.value = await spaceATM.getPersonalSpaceIdAsync();
        // TODO：需显示协作空间列表时才加载
        listMethods.pullGroupList(true);
        listMethods.pullDirList();
      },
    };

    watch(
      () => innerShow.value,
      val => {
        if (val) {
          methods.initData();
        }
      },
    );

    watch(spaceId, () => {
      dirCrumbs.clear(1);
    });

    watch(crumbsList, (newVal, oldVal) => {
      if (!_.isEqual(oldVal, newVal) && innerShow.value) {
        if (isSearching.value) {
          searchMethods.onCancel();
        }
        listMethods.pullDirList();
      }
    });

    return {
      innerShow,
      steps,
      crumbsList,
      current,
      menuValue,
      searchPath,
      defaultExpanded,

      renderFileNameEle,

      // 获取文件目录列表
      isGroupLoading,
      loading,
      dirPath,
      list,
      hasMore,
      isDirLoading,
      isLoadingMore,
      currentGroupList,
      ...listMethods,

      // 文件搜索相关
      searchKey,
      isSearching,
      isSearchLoading,
      ...searchMethods,

      // 新建文件夹相关
      newFolderName,
      isShowNewFolder,
      isShowNewFolderErrorTips,
      newFolderErrorTips,
      handeleCreateNewFolder,

      ...methods,
    };
  },
});
